import React from 'react';

export const initXml = {
  blocks: {
    blocks: [
      {
        deletable: false,
        type: 'createc_retiro_initial_block',
        x: 10,
        y: 10,
      },
    ],
  },
};

/* eslint-disable */
export const categoryXml = (
  <xml>
    <category id="Control" categorystyle="control_category" name="%{BKY_LANG_CATEGORY_CONTROLS}">
      <label text="%{BKY_LANG_CATEGORY_CONTROLS}" />
      <block type="controls_if_no_else" />
      <block type="controls_repeat_educabot">
        <value name="TIMES">
          <shadow type="math_number">
            <field name="NUM">10</field>
          </shadow>
        </value>
      </block>
    </category>

    <category id="inputs" categorystyle="inputs_category" name="%{BKY_LANG_CATEGORY_COMPARISON}">
      <label text="%{BKY_LANG_CATEGORY_COMPARISON}" />
      <block type="createc_logic_compare_ldr">
        <value name="A">
          <block type="train_createc_ciudad_ldr" />
        </value>
      </block>
      <block type="createc_logic_compare_train">
        <value name="A">
          <block type="createc_train_passing" />
        </value>
      </block>
    </category>

    <category id="outputs" categorystyle="outputs_category" name="%{BKY_LANG_CATEGORY_LIGHTNING}">
      <label text="%{BKY_LANG_CATEGORY_LIGHTNING}" />
      <block type="createc_retiro_restore_electricity" />
      <block type="createc_retiro_luminaria_zona2" />
      <block type="createc_retiro_blinking_lights" />
    </category>

    <category id="motors" categorystyle="motors_category" name="%{BKY_LANG_CATEGORY_MOTION}">
      <label text="%{BKY_LANG_CATEGORY_MOTION}" />
      <block type="createc_retiro_train_frequency">
        <value name="TIMES">
          <shadow type="math_number">
            <field name="NUM">10</field>
          </shadow>
        </value>
      </block>
      <block type="createc_retiro_train_service" />
      <block type="createc_retiro_barriers" />
    </category>
  </xml>
);
/* eslint-enable */
